angular.module('account').controller('EmailOptOutLayoutCtrl',
    ['$scope', '$state',
        function () {
            'use strict';
        }]);


